export const SET_TRACK = 'SET_TRACK';
export const SET_TRACK_USERS = 'SET_TRACK_USERS';
export const ADD_TRACK_USER = 'ADD_TRACK_USER';
export const SET_TRACK_SCENARIO = 'SET_TRACK_SCENARIO';
export const SET_TRACK_STEP = 'SET_TRACK_STEP';
